var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsight({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.482 13.992c.359-.5.57-1.113.57-1.775A3.056 3.056 0 0010 9.165a3.056 3.056 0 00-3.052 3.052A3.056 3.056 0 0010 15.27c.662 0 1.274-.212 1.775-.57l2.216 2.216a.498.498 0 00.707 0 .5.5 0 000-.707l-2.216-2.217zm-4.534-1.775c0-1.131.92-2.052 2.052-2.052 1.132 0 2.053.92 2.053 2.052 0 1.132-.921 2.053-2.053 2.053a2.055 2.055 0 01-2.052-2.053zm9.986.248a8.007 8.007 0 01-2.782 2.857.5.5 0 01-.526-.85 7.046 7.046 0 002.291-2.254c-1.373-2.179-3.995-3.52-6.917-3.52-2.923 0-5.544 1.34-6.917 3.52 1.89 3.018 5.598 3.883 8.502 3.386a.5.5 0 01.169.985c-.576.099-1.161.148-1.746.148-1.287 0-2.57-.237-3.733-.698-1.835-.728-3.29-1.964-4.21-3.574a.5.5 0 010-.495c.775-1.357 1.955-2.468 3.412-3.213 1.356-.693 2.92-1.06 4.523-1.06 1.603 0 3.167.367 4.523 1.06 1.457.745 2.637 1.856 3.411 3.213a.5.5 0 010 .495zM9.5 5.987v-2.55a.5.5 0 111 0v2.55a.5.5 0 01-1 0zm3.182.585l1.275-2.208a.5.5 0 11.866.5l-1.275 2.208a.5.5 0 11-.866-.5zM5.177 4.864a.5.5 0 01.866-.5l1.275 2.208a.5.5 0 01-.866.5L5.177 4.864z"
  })));
}

export default SvgInsight;